<template>
  <v-dialog v-model="show" max-width="950px" :fullscreen="isMobile">
    <booking-group-dialog-content
      :booking-group="bookingGroup"
      :charges="charges"
      :accommodation-sums="accommodationSums"
      :bookings-accommodation-sums="bookingsAccommodationSums"
      :invoices="invoices"
      :receipts="receipts"
      :receipt-payments="receiptPayments"
      :invoice-payment-applications="invoicePaymentApplications"
      :editing-records="editingRecords"
      :emails="emails"
      :is-loading="isLoading"
      :is-open="show"
      @close="close"
    ></booking-group-dialog-content>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import BookingGroupDialogContent from './DialogContent.vue'

export default {
  name: 'BookingGroupDialog',
  components: {
    BookingGroupDialogContent
  },
  data: () => ({}),
  computed: {
    ...mapState(
      {
        bookingGroup: state => state.bookingGroup.dialog.bookingGroup,
        charges: state => state.bookingGroup.dialog.charges,
        accommodationSums: state => state.bookingGroup.dialog.accommodationSums,
        bookingsAccommodationSums: state => state.bookingGroup.dialog.bookingsAccommodationSums,
        invoices: state => state.bookingGroup.dialog.invoices,
        receipts: state => state.bookingGroup.dialog.receipts,
        receiptPayments: state => state.bookingGroup.dialog.receiptPayments,
        invoicePaymentApplications: state => state.bookingGroup.dialog.invoicePaymentApplications,
        emails: state => state.bookingGroup.dialog.emails,
        editingRecords: state => state.bookingGroup.dialog.editingRecords,
        isLoading: state => state.bookingGroup.dialog.isLoading,
        showDialog: state => state.bookingGroup.dialog.show
      }
    ),
    show: {
      get () {
        return this.showDialog
      },
      set (value) {
        this.$store.commit('bookingGroup/SET_SHOW_DIALOG', value)
      }
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    close: function () {
      this.show = false
    }
  }
}
</script>
